import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route, useHistory, withRouter } from 'react-router-dom'
import { withAuthentication } from './components/session';

import NotFound from './components/useful/NotFound';
import LoadingPage from './components/useful/LoadingPage';
import Navigation from './components/Navigation';
import Login from './components/user/Login';
import PasswordChange from './components/user/PasswordChange';
import Home from './components/home/Home';
import PremiumUser from './components/admin/PremiumUser/PremiumUser';
import TournamentList from './components/TournamentList/TournamentList';
import TournamentPage from './components/Tournament/TournamentPage';
import TeamPage from './components/Team/TeamPage';
import PasswordReset from './components/user/PasswordReset';
import PremiumUserPage from './components/admin/PremiumUserPage/PremiumUserPage';

import PullToRefresh from 'pulltorefreshjs';
import AdsList from './components/admin/Ads/AdList';
import PrivacyPolicy from './components/useful/PrivacyPolicy';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    }
  }

  componentDidMount() {
    PullToRefresh.init({
      mainElement: 'body',
      onRefresh() {
        window.location.reload();
      },
      triggerElement: "nav.navbar",
      instructionsPullToRefresh: " ",
      instructionsReleaseToRefresh: " ",
      instructionsRefreshing: " ",
    });
    this.showLoadingPage();
  }

  componentWillUnmount() {
    PullToRefresh.destroyAll();
  }

  showLoadingPage = () => {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  }

  render() {
    const { isLoading } = this.state;

    const loadingPage = isLoading ? <LoadingPage /> : '';

    return (
      <div>

        {loadingPage}

        <BrowserRouter>
          <Switch>

            <Route exact path="/privacy_policy" component={PrivacyPolicy} />

            <Route component={({ match }) =>
              <>
                <Navigation />

                <div className="container h-100 mt-3">
                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/tournaments" component={TournamentList} />
                    <Route exact path="/tournaments/:tournament_uid" component={TournamentPage} />
                    <Route exact path="/tournaments/:tournament_uid/team/:team_uid" component={TeamPage} />
                    <Route exact path="/users" component={PremiumUser} />
                    <Route exact path="/user/:user_uid" component={PremiumUserPage} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/password_reset" component={PasswordReset} />
                    <Route exact path="/passwordchange" component={PasswordChange} />
                    <Route exact path="/ads" component={AdsList} />
                    <Route component={NotFound} />
                  </Switch>
                </div>
              </>
            } />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withAuthentication(App);
